import { createFileRoute, Link, useRouter } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { userManager } from '@/auth/oidc'
import { EmptyState } from '@/components/page'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/auth/callback')({ component: AuthCallback })

// Der Code darf nur einmal eingelöst werden; React StrictMode führt Effekte im Dev doppelt aus.
let pendingCallback: Promise<string> | null = null

function completeSignin(): Promise<string> {
  pendingCallback ??= userManager()
    .signinRedirectCallback()
    .then((user) => {
      const state = user.state as { returnTo?: string } | undefined
      return state?.returnTo?.startsWith('/') ? state.returnTo : '/'
    })
  return pendingCallback
}

function AuthCallback() {
  const { t } = useTranslation()
  const router = useRouter()
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    completeSignin().then(
      (returnTo) => void router.navigate({ to: returnTo, replace: true }),
      () => {
        pendingCallback = null
        setFailed(true)
      },
    )
  }, [router])

  return (
    <main id="main-content" className="mx-auto max-w-xl p-6">
      {failed ? (
        <EmptyState title={t('authCallback.errorTitle')} body={t('authCallback.errorBody')}>
          <Button asChild>
            <Link to="/login">{t('login.button')}</Link>
          </Button>
        </EmptyState>
      ) : (
        <p role="status" className="py-20 text-center text-muted-foreground">
          {t('authCallback.working')}
        </p>
      )}
    </main>
  )
}
